export const getDashboardLink = function (company, accountType) {
  let claimGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (company.dashboard_type === 'business_unit_intensity_breakdown' && claimGroup) {
    return `/${accountType}/claim_groups/${claimGroup.id}/regular_realtime_dashboard/${company.id}`;
  }
  if (claimGroup) {
    return `/${accountType}/claim_groups/${claimGroup.id}/dashboard/${company.id}`;
  }
  return company.dashboard_type === 'business_unit_intensity_breakdown' ? `/${accountType}/regular_realtime_dashboard/${company.id}` : `/${accountType}/dashboard/${company.id}`;
};